import { MappingActivityDestination } from 'app/constants/configuration/mappingActivityDestination'

export const getMappingActivityDestination = (
  type: number,
): MappingActivityDestination => {
  let mappingActivityDestination = MappingActivityDestination.Driving

  switch (type) {
    case 1:
      mappingActivityDestination = MappingActivityDestination.Availability
      break
    case 2:
      mappingActivityDestination = MappingActivityDestination.UnauthorizedBreaks
      break
    case 3:
      mappingActivityDestination = MappingActivityDestination.Duty50
      break
    case 4:
      mappingActivityDestination = MappingActivityDestination.Duty100
      break
    case 5:
      mappingActivityDestination = MappingActivityDestination.Rest
      break
  }

  return mappingActivityDestination
}
